/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Ward from './ward';
import WardDetail from './ward-detail';
import WardUpdate from './ward-update';
import WardDeleteDialog from './ward-delete-dialog';

const WardRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Ward />} />
    <Route path="new" element={<WardUpdate />} />
    <Route path=":id">
      <Route index element={<WardDetail />} />
      <Route path="edit" element={<WardUpdate />} />
      <Route path="delete" element={<WardDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WardRoutes;
